import LoginPage from 'components/LoginPage';
import i18n from 'i18n';
import { AuthenticateData } from 'modules/authenticate/interfaces';
import React from 'react';
import { connect } from 'react-redux';
import { history } from 'store';
import { privacyLink, ethicsLink } from 'utils/helpers';
import useWindowDimensions from 'hooks/useWindowWidth';
import FormMFA from './FormMFA';

interface OwnProps {
  data: AuthenticateData;
}

const ConfigureMFA: React.FC<OwnProps> = ({ data }) => {
  const { width } = useWindowDimensions();
  React.useEffect(() => {
    if (!data?.mfa) history.push('/');
  }, [data]);

  const image =
    width < 960
      ? '/images/login/mobileImage.png'
      : '/images/login/login1WithLogo.png';

  return (
    <LoginPage
      logoHeaderUrl="/images/AutoSkyLogoColorido.svg"
      backgroundImageUrl={image}
      links={[
        {
          name: i18n.t('PRIVACY_POLICY_KEY'),
          url: privacyLink[i18n.language],
        },
        {
          name: i18n.t('CODE_OF_ETHICS_KEY'),
          url: ethicsLink[i18n.language],
        },
      ]}
    >
      {data?.mfa?.required && <FormMFA language={i18n.language} />}
    </LoginPage>
  );
};

const mapStateToProps = ({ authenticate }) => ({
  data: authenticate.data,
});

export default connect(mapStateToProps)(ConfigureMFA);
